import React from 'react';
import { useMsal } from '@azure/msal-react';

interface Props {
  /** true = refus module (bouton retour accueil), false = refus portail (bouton déconnexion) */
  moduleLevel?: boolean;
}

const AccessDenied: React.FC<Props> = ({ moduleLevel = false }) => {
  const { instance } = useMsal();

  return (
    <div className={`${moduleLevel ? 'py-16' : 'min-h-screen'} bg-ms-gray-50 flex items-center justify-center`}>
      <div className="bg-white rounded-lg shadow-sm border border-ms-gray-200 p-8 max-w-md text-center">
        <div className="w-16 h-16 bg-ms-red/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-ms-red" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-ms-gray-800 mb-2">Accès refusé</h2>
        <p className="text-ms-gray-500 mb-4">
          {moduleLevel
            ? "Vous n'avez pas accès à ce module. Contactez votre administrateur IT pour demander l'accès."
            : "Vous n'êtes pas autorisé à accéder à cette application. Contactez votre administrateur IT."}
        </p>
        {moduleLevel ? (
          <button
            onClick={() => { window.location.href = '/'; }}
            className="px-4 py-2 bg-ms-blue text-white rounded-md hover:bg-ms-blue-dark transition-colors text-sm"
          >
            Retour à l'accueil
          </button>
        ) : (
          <button
            onClick={() => instance.logoutRedirect()}
            className="px-4 py-2 bg-ms-blue text-white rounded-md hover:bg-ms-blue-dark transition-colors text-sm"
          >
            Se déconnecter
          </button>
        )}
      </div>
    </div>
  );
};

export default AccessDenied;
